const KEY_BINDINGS={ENTER:"Enter",TAB:"Tab"};export default KEY_BINDINGS;